import { useContext } from 'react';
import { UserProfileContext } from '../contexts/UserProfileContext';

export const useUserProfile = () => {
  const context = useContext(UserProfileContext);
  if (context === undefined) {
    throw new Error('useUserProfile debe ser usado dentro de un UserProfileProvider');
  }
  return context;
};
